export default __webpack_public_path__ + "static/butik_img1-19c64c4b7afc7051c6c97844005497af.png";